<template>
  <BaseModal
    name="placeEditModal"
    :clickToClose="false"
    :shiftY="0.5"
    :adaptive="true"
    height="auto"
    _resizable="true"
    :scrollable="true"
    :width="860"
    classes="tw-app-modal !tw-h-auto"
    @before-open="beforeOpen"
    @before-close="beforeClose"
  >
    <div
      class="tw-app-modal__container !tw-px-[15px] !tw-pb-[20px] !tw-pt-[48px] !tw-bg-[#FAFBFC] !tw-min-h-[582px]"
    >
      <BaseLoader v-if="localLoading" class="tw-rounded-[25px]"></BaseLoader>
      <button
        type="button"
        class="btn-close tw-app-modal__close"
        @click="$modal.hide('placeEditModal')"
      ></button>

      <div>
        <div class="">
          <div class="tw-grid tw-grid-cols-[55%_auto] tw-gap-[10px]">
            <div class="tw-bg-white tw-py-[8px] tw-px-[15px] tw-rounded-[8px]">
              <div class="tw-text-[12px] tw-font-[700] tw-mb-[10px]">
                {{ dataLang.city_delivery_register_text_22 }}
              </div>

              <div
                class="tw-flex tw-justify-between tw-items-center tw-mb-[5px]"
                ref="vehicle_places__city_id"
              >
                <div class="tw-text-[11px]">
                  {{ dataLang.city_delivery_register_text_8 }}
                </div>
                <div class="multiselect-type-2">
                  <BaseSelect
                    placeholder=""
                    style="width: 297px"
                    selectLabel=""
                    deselectLabel=""
                    @input="
                      (data) =>
                        setSimpleSelect({
                          key: 'vehicle_places__city_id',
                          value: data.cities__id,
                        })
                    "
                    v-model="selectsFromModal.cities"
                    disabled
                    :options="selectsData.cities"
                    label="cities__name"
                  >
                    <template slot="noOptions">{{
                      dataLang["select_empty"]
                    }}</template>
                    <template slot="noResult">{{
                      dataLang["select_search_empty"]
                    }}</template
                    ><template slot="selectedLabel">{{
                      dataLang["select_selected"]
                    }}</template>
                    <template slot="deselectLabel">{{
                      dataLang["select_unselect"]
                    }}</template>
                  </BaseSelect>
                </div>
              </div>

              <div class="tw-mb-[5px]" ref="vehicle_places__address">
                <BaseInputNew
                  inputClass="tw-app-input-type-2"
                  width="299"
                  input-name="vehicle_places__address"
                  maxLength="100"
                  @input="updateValueCitiesCenter"
                  :horizontalTitle="true"
                  :value="valueAddress"
                  @selectData="onSelectFromAddress"
                  :additionalParams="{}"
                  :name-sign="dataLang.city_delivery_register_text_38"
                  :options="addressOptions"
                  selectKey="formatted_address"
                  selectFocusmethod="input"
                >
                </BaseInputNew>
              </div>

              <div class="tw-mb-[5px]" ref="vehicle_places__name">
                <BaseInputNew
                  inputClass="tw-app-input-type-2"
                  input-name="vehicle_places__name"
                  maxLength="100"
                  @input="updateValue"
                  :horizontalTitle="true"
                  width="299"
                  :value="dataForModal.vehicle_places__name"
                  :additionalParams="{}"
                  :name-sign="dataLang.city_delivery_register_text_10"
                >
                </BaseInputNew>
              </div>

              <div
                class="tw-flex tw-justify-between tw-items-center tw-mb-[5px]"
                ref="vehicle_places__work_hours_start"
              >
                <div class="tw-text-[11px]">
                  {{ dataLang.city_delivery_register_text_23 }}
                </div>
                <BaseDatePicker
                  input-class="tw-app-input-type-2 tw-text-[11px] tw-w-full"
                  v-model="selectTime.start"
                  type="time"
                  lang="ru"
                  id="vehicle_places__work_hours_start"
                  style="width: 299px"
                  value-type="format"
                  :format="`HH:mm`"
                  @change="
                    (date) =>
                      updateValue({
                        name: 'vehicle_places__work_hours_start',
                        value: date,
                      })
                  "
                >
                </BaseDatePicker>
              </div>

              <div
                class="tw-flex tw-justify-between tw-items-center tw-mb-[5px]"
                ref="vehicle_places__work_hours_end"
              >
                <div class="tw-text-[11px]">
                  {{ dataLang.city_delivery_register_text_24 }}
                </div>
                <BaseDatePicker
                  input-class="tw-app-input-type-2 tw-text-[11px] tw-w-full"
                  v-model="selectTime.end"
                  type="time"
                  lang="ru"
                  id="vehicle_places__work_hours_end"
                  style="width: 299px"
                  value-type="format"
                  :format="`HH:mm`"
                  @change="
                    (date) =>
                      updateValue({
                        name: 'vehicle_places__work_hours_end',
                        value: date,
                      })
                  "
                >
                </BaseDatePicker>
              </div>

              <div class="tw-mb-[5px]" ref="vehicle_places__phone">
                <BaseInputNew
                  inputClass="tw-app-input-type-2"
                  width="299"
                  input-name="vehicle_places__phone"
                  @input="updateValue"
                  :horizontalTitle="true"
                  inputRef="vehicle_places__phone"
                  inputMask="+{7}(000)000-00-00"
                  maxLength="16"
                  :value="dataForModal.vehicle_places__phone"
                  :additionalParams="{}"
                  :name-sign="dataLang.city_delivery_register_text_11"
                >
                </BaseInputNew>
              </div>

              <div
                class="tw-flex tw-justify-between tw-items-center tw-mb-[5px]"
                ref="vehicle_places__is_open"
              >
                <div class="tw-text-[11px]">
                  {{ dataLang.city_delivery_register_text_12 }}
                </div>
                <div class="multiselect-type-2">
                  <BaseSelect
                    placeholder=""
                    style="width: 297px"
                    selectLabel=""
                    deselectLabel=""
                    @input="
                      (data) =>
                        updateValue({
                          name: 'vehicle_places__is_open',
                          value: data.value,
                        })
                    "
                    v-model="selectsFromModal.isOpen"
                    :options="[
                      { label: dataLang['places_open_true'], value: 1 },
                      { label: dataLang['places_open_false'], value: 0 },
                    ]"
                    label="label"
                  >
                    <template slot="noOptions">{{
                      dataLang["select_empty"]
                    }}</template>
                    <template slot="noResult">{{
                      dataLang["select_search_empty"]
                    }}</template
                    ><template slot="selectedLabel">{{
                      dataLang["select_selected"]
                    }}</template>
                    <template slot="deselectLabel">{{
                      dataLang["select_unselect"]
                    }}</template>
                  </BaseSelect>
                </div>
              </div>

              <div class="tw-text-[12px] tw-font-[700] tw-my-[10px]">
                {{ dataLang.city_delivery_register_text_39 }}
              </div>

              <!-- таблица -->
              <div class="thisTable">
                <table class="tw-text-[11px]">
                  <thead>
                    <tr>
                      <th>Вид ТС</th>
                      <th>Мест</th>
                      <th>Занято</th>
                      <th class="tw-whitespace-nowrap">Своих/Чужих</th>
                      <th>Свободно</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in dataForModal?.capacities">
                      <td
                        :isActive="
                          dataForModal.capacities[listIndex[index] - 1]
                            ?.place_capacity__is_active
                        "
                      >
                        {{
                          dataLang[
                            dataForModal.capacities[listIndex[index] - 1]
                              ?.vehicle_types__code
                          ]
                        }}
                      </td>
                      <td>
                        <BaseInputNew
                          inputClass="tw-app-input-type-2 tw-text-center !tw-py-[6px]"
                          placeholder=""
                          input-name="place_capacity__capacity"
                          maxLength="100"
                          @input="updateValue"
                          :horizontalTitle="true"
                          :value="
                            dataForModal.capacities[listIndex[index] - 1]
                              ?.place_capacity__capacity
                          "
                          :additionalParams="{
                            ...dataForModal.capacities[listIndex[index] - 1],
                            type: 'capacities',
                          }"
                        >
                        </BaseInputNew>
                      </td>
                      <td>
                        {{
                          dataForModal.capacities[listIndex[index] - 1]
                            ?.percent
                        }}%
                      </td>
                      <td>
                        {{
                          dataForModal.capacities[listIndex[index] - 1]
                            ?.countMyObjects
                        }}/{{
                          dataForModal.capacities[listIndex[index] - 1]
                            ?.countNotMyObjects
                        }}
                      </td>
                      <td>
                        {{
                          dataForModal.capacities[listIndex[index] - 1]
                            ?.place_capacity__capacity -
                          dataForModal.capacities[listIndex[index] - 1]
                            ?.countMyObjects -
                          dataForModal.capacities[listIndex[index] - 1]
                            ?.countNotMyObjects
                        }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- таблица -->
            </div>
            <div
              class="tw-bg-white tw-py-[8px] tw-px-[15px] tw-rounded-[8px] tw-overflow-hidden"
            >
              <div>
                <div
                  class="tw-flex tw-items-center tw-gap-[10px] tw-text-[12px] tw-font-[700] tw-mb-[10px]"
                >
                  {{ dataLang.city_delivery_register_text_40 }}
                  <label class="form-switch ps-0">
                    <input
                      type="checkbox"
                      :checked="showDeliveres"
                      @input="
                        (e) => {
                          updateValue({
                            value: e.target.checked,
                            name: 'vehicle_places__is_delivery',
                          });
                          showDeliveres = e.target.checked;
                        }
                      "
                    />
                    <i></i>
                  </label>
                </div>
                <table
                  class="table-delivery tw-mx-[-16px]"
                  v-if="showDeliveres"
                >
                  <tr>
                    <td class="tw-font-[700]">Место</td>
                    <td class="tw-font-[700]">
                      <div class="table-delivery__box">
                        <BaseCheckboxV2
                          v-model="
                            dataForModal.vehicle_places__is_delivery_worktime
                          "
                          placeholder=""
                          class="d-block"
                          @oncheckeds="updateValue"
                          input-name="vehicle_places__is_delivery_worktime"
                          >{{ "" }}</BaseCheckboxV2
                        >
                        <div class="tw-mt-[5px]">Рабочее время</div>
                      </div>
                    </td>
                    <td class="tw-font-[700]">
                      <div class="table-delivery__box">
                        <BaseCheckboxV2
                          v-model="
                            dataForModal.vehicle_places__is_delivery_not_worktime
                          "
                          class="d-block"
                          placeholder=""
                          @oncheckeds="updateValue"
                          input-name="vehicle_places__is_delivery_not_worktime"
                          >{{ "" }}</BaseCheckboxV2
                        >
                        <div class="tw-mt-[5px]">Нерабочее время</div>
                      </div>
                    </td>
                  </tr>
                  <tr
                    v-for="(item, index) in dataForModal.deliveries"
                    :key="index"
                  >
                    <td>{{ item.place_deliveries__address }}</td>
                    <td>
                      <BaseInputNew
                        inputClass="tw-app-input-type-2 tw-text-center !tw-py-[6px]"
                        placeholder=""
                        input-name="place_deliveries__part_1_cost"
                        maxLength="100"
                        @input="updateValue"
                        :horizontalTitle="true"
                        :value="item.place_deliveries__part_1_cost"
                        :additionalParams="{ type: 'delivery', ...item }"
                      >
                      </BaseInputNew>
                    </td>
                    <td>
                      <BaseInputNew
                        inputClass="tw-app-input-type-2 tw-text-center !tw-py-[6px]"
                        placeholder=""
                        input-name="place_deliveries__part_2_cost"
                        maxLength="100"
                        @input="updateValue"
                        :horizontalTitle="true"
                        :value="item.place_deliveries__part_2_cost"
                        :additionalParams="{ type: 'delivery', ...item }"
                      >
                      </BaseInputNew>
                    </td>
                  </tr>
                </table>

                <div class="tw-mt-[10px]">
                  <div class="tw-text-[11px] tw-font-[700] tw-mb-[5px]">
                    Комментарий
                  </div>
                  <BaseTextarea
                    placeholder=""
                    :disabled="true"
                    inputClass="tw-app-input-type-3"
                    @onInput="updateValue"
                    minHeight="75"
                    :maxLength="499"
                    :resize="false"
                    input-name="vehicle_places__comment"
                    :value="dataForModal.vehicle_places__comment"
                  >
                  </BaseTextarea>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="tw-bg-danger tw-mx-[15px] tw-px-[15px] tw-py-[11px] tw-text-[12px] tw-text-white tw-font-[600]"
          v-if="dataForModal?.clients__is_blacklisted"
          v-html="dataLang['clients_register_text_95']"
        ></div>

        <div class="tw-app-modal__footer !tw-justify-end tw-mx-[15px]">
          <button
            @click="$modal.hide('placeEditModal')"
            class="tw-app-btn-muted tw-app-btn-muted-lg"
          >
            {{ dataLang["orders_model_edit__btn_text5"] }}
          </button>
          <button
            @click="sendData"
            class="tw-app-btn-primary tw-app-btn-primary-lg"
          >
            {{ dataLang["orders_model_edit__btn_text6"] }}
          </button>
        </div>
      </div>
    </div>
  </BaseModal>
</template>

<script>
import { mapActions, mapState, mapMutations, mapGetters } from "vuex";
import GeneralService from "@/api/GeneralService";
import EventBus from "@/event-bus";

export default {
  components: {},
  props: {},
  data() {
    return {
      showDeliveres: false,
      updatedValues: {},
      currentOpenedId: "",
      dataForModal: {},
      newTab: null,
      oldTab: null,
      mainInfo: {},
      localLoading: true,
      cities: [],
      selectsFromModal: {
        countries: [],
        isOpen: [],
        region: [],
        time: [],
        integrator: [],
        cities: [],
      },
      selectTime: { start: [], end: [] },
      // listIndex: [1, 8, 2, 4, 3, 7, 6, 5],
      listIndex: [1, 3, 2],
      selectsData: {
        countries: [],
        region: [],
        cities: [],
        time: [],
        places: [],
      },
      deliveryUpdateData: [],
      capacitiesUpdateData: [],
      timeout: null,
      valueAddress: "",
      addressOptions: [],
    };
  },
  methods: {
    updateValueCitiesCenter(e) {
      this.valueAddress = e.value;
      this.updatedValues.vehicle_places__address = e.value;
      this.addressOptions = [];
      clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        let data = await fetch(
          `https://suggest-maps.yandex.ru/v1/suggest?text=${e.value}&apikey=ebc56b08-9998-443e-99e9-e0a70c2cd1c1&print_address=1&types=country,house,house,district,geo,street,locality&lang=ru&results=15`
        );
        let dataFromJson = await data.json();
        dataFromJson.results.forEach((elem, index) => {
          this.addressOptions.push(elem.address);
        });
      }, 400);
    },
    onSelectFromAddress(e) {
      this.valueAddress = e.value.formatted_address;
      this.updatedValues.vehicle_places__address = e.value.formatted_address;
    },
    updateValue(data) {
      // console.log(data);
      let indexedDelivery;
      let indexedCapacities;
      //   capacitiesUpdateData
      if (data.type && data.type == "delivery") {
        indexedDelivery = this.deliveryUpdateData.findIndex(
          (x) => x.place_deliveries__id == data.place_deliveries__id
        );
        if (indexedDelivery !== -1) {
          this.deliveryUpdateData[indexedDelivery][data.name] = data.value;
        } else {
          this.deliveryUpdateData.push({
            place_deliveries__id: data.place_deliveries__id,
          });
        }
      }
      if (data.type && data.type == "capacities") {
        indexedCapacities = this.capacitiesUpdateData.findIndex(
          (x) =>
            x.place_capacity__vehicle_type_id ==
            data.place_capacity__vehicle_type_id
        );
        if (indexedCapacities !== -1) {
          this.capacitiesUpdateData[indexedCapacities][data.name] = data.value;
          //поставим галку если мы изменили количество мест
          if (data.name == "place_capacity__capacity") {
            this.capacitiesUpdateData[
              indexedCapacities
            ].place_capacity__is_active = !!+data.value ? 1 : 0;
          }
        } else {
          this.capacitiesUpdateData.push({
            place_capacity__vehicle_type_id:
              data.place_capacity__vehicle_type_id,
            [data.name]: data.value,
            // data.name == 'place_capacity__is_active' &&  ?
            //   place_capacity__is_active: data.place_capacity__is_active : ""
          });
        }
      }
      if (!data.type) {
        this.updatedValues[data.name] = data.value;
      }

      if (this.$refs[data.name]) {
        this.$refs[data.name].classList.remove("input-error");
      }
    },
    setSimpleSelect(data, id) {
      this.updatedValues[data.key] = data.value;

      if (this.$refs[data.key]) {
        this.$refs[data.key].classList.remove("input-error");
      }
    },
    sendData() {
      this.localLoading = true;
      GeneralService.edit(`/places/${this.currentOpenedId}`, {
        ...this.updatedValues,
        ...(this.capacitiesUpdateData.length && {
          capacities: this.capacitiesUpdateData,
        }),
        ...(this.deliveryUpdateData.length && {
          deliveries: this.deliveryUpdateData,
        }),
      })
        .then((data) => {
          EventBus.$emit("updateContentData");
          this.$modal.hide("placeEditModal");
          this.$toast.success(data.data.message);
          this.updatedValues = {};
          this.capacitiesUpdateData = [];
          this.deliveryUpdateData = [];
        })
        .catch((error) => {
          this.localLoading = false;
          Object.keys(error.response.data.errors).forEach((elem, index) => {
            if (this.$refs[elem]) {
              this.$refs[elem].classList.add("input-error");
            }
          });
          this.$toast.error(error.response.data.message, { duration: 5000 });
        });
    },
    beforeOpen(data) {
      this.currentOpenedId = data.params.id;
      Promise.all([
        GeneralService.get("/places/cities", {
          params: {
            limit: 5000,
          },
        })
          .then((data) => {
            this.selectsData.cities = data.data.data.rows;
          })
          .catch((error) => {}),
      ]).then(() => {
        GeneralService.get(`/places/${data.params.id}?joins=delivery,capacity`)
          .then((data) => {
            this.dataForModal = data.data.rows[0];
            this.dataForModal.capacities = this.dataForModal.capacities.filter(
              (i) =>
                i.vehicle_types__code == "car" ||
                i.vehicle_types__code == "water" ||
                i.vehicle_types__code == "air"
            );
            this.localLoading = false;
            this.valueAddress = this.dataForModal.vehicle_places__address;
            this.selectsFromModal.cities = this.selectsData.cities.find(
              (x) => x.cities__id == this.dataForModal.vehicle_places__city_id
            );

            this.selectTime.start =
              this.dataForModal.vehicle_places__work_hours_start;
            this.selectTime.end =
              this.dataForModal.vehicle_places__work_hours_end;
            this.selectsFromModal.isOpen = this.dataForModal
              .vehicle_places__is_open
              ? { label: this.dataLang["places_open_true"], value: 1 }
              : { label: this.dataLang["places_open_false"], value: 0 };
            this.showDeliveres = this.dataForModal.vehicle_places__is_delivery;
          })
          .catch((e) => {});
      });
    },
    beforeClose() {
      this.updatedValues = {};
      this.dataForModal = {};
      this.localLoading = true;
      (this.deliveryUpdateData = []), (this.capacitiesUpdateData = []);
      this.currentOpenedId = null;
      this.selectsFromModal = {
        countries: [],
        region: [],
        time: [],
        integrator: [],
        cities: [],
      };
      this.showDeliveres = false;
      this.selectTime = { start: [], end: [] };
    },
    prepareLabelsForDefaultSelects(data, keyDataFromFetch, toTranslate) {
      for (const key in data) {
        data[key].forEach((element) => {
          element["label"] = element[Object.keys(element).pop()];
          element["key"] = key;
          element["value"] = Object.keys(element)[0];
          element["selectName"] = keyDataFromFetch;
        });
      }
      return data;
    },
  },
  mounted() {
    this.selectsFromModal.isOpen = {
      label: this.dataLang["places_open_false"],
      value: 0,
    };
  },
  created() {},
  computed: {
    ...mapState("translationModule", ["dataLang"]),
    ...mapState("userSettingModule", ["userSetting"]),
  },
};
</script>

<style lang="scss" scoped>
.thisTable {
  table {
    border-collapse: collapse;
    background-color: #ffffff;
  }
  th,
  td {
    border: 1px solid #dce0ed;
    text-align: center;
  }
  td {
    padding: 3px 5px;
  }
  th {
    padding: 9px 10px;
    background-color: #eef4fa;
    font-weight: normal;
  }
  td:first-child,
  th:first-child {
    padding: 3px 10px;
    text-align: left;
  }
}

.table-delivery {
  text-align: center;
  font-size: 11px;
  width: 100%;

  & tr:first-child td {
    min-width: 122px;
    padding-top: 5px;
  }

  td {
    border: 1px solid #dce0ed;
    padding: 3px 5px;
  }

  tr:nth-child(2n) {
    background: #f2f3f5;
    /* Цвет фона */
  }

  &__box {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}

.form-switch {
  display: inline-block;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  padding-left: 0;
}

.form-switch i {
  position: relative;
  display: inline-block;
  margin-right: 0.5rem;
  width: 46px;
  height: 26px;
  background-color: white;
  border-radius: 23px;
  vertical-align: text-bottom;
  transition: all 0.3s linear;
}

.form-switch i::before {
  content: "";
  position: absolute;
  left: 0;
  width: 42px;
  height: 22px;
  background-color: #f5f5f5;
  border-radius: 11px;
  transform: translate3d(2px, 2px, 0) scale3d(1, 1, 1);
  transition: all 0.25s linear;
}

.form-switch i::after {
  content: "";
  position: absolute;
  left: 0;
  width: 22px;
  height: 22px;
  background-color: #23b14d;
  border-radius: 11px;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.24);
  transform: translate3d(2px, 2px, 0);
  transition: all 0.2s ease-in-out;
}

.form-switch:active i::after {
  width: 28px;
  transform: translate3d(2px, 2px, 0);
}

.form-switch:active input:checked + i::after {
  transform: translate3d(16px, 2px, 0);
}

.form-switch input {
  display: none;
}

.form-switch input:checked + i {
  background-color: #f5f5f5 !important;
}

.form-switch input:checked + i::before {
  transform: translate3d(18px, 2px, 0) scale3d(0, 0, 0);
}

.form-switch input:checked + i::after {
  transform: translate3d(22px, 2px, 0);
}
</style>
